import { BarChart01 } from '@untitledui/icons';

// Environment variables for future Metabase integration
// const METABASE_SITE_URL = import.meta.env.VITE_METABASE_SITE_URL;
// const METABASE_DASHBOARD_ID = import.meta.env.VITE_METABASE_DASHBOARD_ID;

export const MetabaseAnalyticsTab = () => {
    // TODO: When Metabase is configured, implement embedding:
    // 1. Generate JWT token for embedding
    // 2. Construct iframe URL with token
    // 3. Replace placeholder with iframe

    return (
        <div className="space-y-6">
            {/* Metabase Placeholder Card */}
            <div className="rounded-lg border border-secondary bg-primary p-6">
                <div className="mb-6">
                    <h3 className="text-lg font-semibold text-primary">
                        Business Analytics
                    </h3>
                    <p className="text-tertiary text-sm mt-1">
                        Powered by Metabase
                    </p>
                </div>

                {/* Placeholder Content */}
                <div className="flex flex-col items-center justify-center py-16 px-8 bg-secondary rounded-lg">
                    <div className="w-16 h-16 rounded-full bg-tertiary/10 flex items-center justify-center mb-6">
                        <BarChart01 className="w-8 h-8 text-tertiary" />
                    </div>

                    <h4 className="text-lg font-semibold text-primary mb-2">
                        Metabase Integration Coming Soon
                    </h4>

                    <p className="text-tertiary text-sm text-center max-w-md mb-6">
                        Advanced analytics dashboards will be available here once Metabase is configured.
                    </p>

                    {/* Features List */}
                    <div className="w-full max-w-sm space-y-3">
                        <p className="text-sm font-medium text-primary mb-2">Planned Features:</p>
                        <ul className="space-y-2">
                            {[
                                'Document processing metrics',
                                'Container tracking analytics',
                                'Company usage statistics',
                                'AI cost analysis',
                                'Performance dashboards'
                            ].map((feature, index) => (
                                <li key={index} className="flex items-center gap-2 text-sm text-tertiary">
                                    <span className="w-1.5 h-1.5 rounded-full bg-brand-500" />
                                    {feature}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Configuration Note */}
                <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                    <p className="text-sm text-blue-700">
                        <span className="font-medium">Configuration Required:</span>{' '}
                        Set <code className="px-1 py-0.5 bg-blue-100 rounded text-xs">VITE_METABASE_SITE_URL</code> and{' '}
                        <code className="px-1 py-0.5 bg-blue-100 rounded text-xs">VITE_METABASE_DASHBOARD_ID</code>{' '}
                        environment variables to enable Metabase embedding.
                    </p>
                </div>
            </div>
        </div>
    );
};
